module.exports = __webpack_public_path__ + "img/jrhb.55bd8061.png";